import PropTypes from 'prop-types';
import React from 'react';
import { convertToRaw, Draft } from '@ublend-npm/th90-editor';
import ScheduleIcon from '@material-ui/icons/Schedule';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import styleUtils from '@ublend-npm/aulaui-next-web/styles/utils';

import style from './style';
import Editor from '../../../common/EditorPlus/EditorPlus.container';
import SchedulePostDialog from '../SchedulePostDialog/SchedulePostDialog';

const noop = () => {};

class ClassRoomCreatePost extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();

    this.state = {
      editorState: Draft.EditorState.createEmpty(),
      scheduleDialogOpen: false,
    };

    this.handleCreatePost = this.handleCreatePost.bind(this);
    this.handleScheduleOpen = this.handleScheduleOpen.bind(this);
    this.handleScheduleClose = this.handleScheduleClose.bind(this);
    this.handleSchedulePost = this.handleSchedulePost.bind(this);

    this.ignore = () => {};
  }

  componentWillReceiveProps(nextProps) {
    this.ignore(nextProps.isInInbox);
  }

  async handleCreatePost() {
    this.createPost({});
  }

  async handleSchedulePost(date) {
    this.createPost({ scheduledFor: date });
  }

  handleScheduleOpen() {
    this.setState({ scheduleDialogOpen: true });
  }

  handleScheduleClose() {
    this.setState({ scheduleDialogOpen: false });
  }

  async createPost(additionalData) {
    const { spaceId, createPost } = this.props;
    const { editorState } = this.state;

    await createPost({
      spaceId,
      content: convertToRaw(editorState),
      ...additionalData,
    });

    const voiceNotification = () => {
      const elem = this.myRef.current;
      elem.innerHTML = `<p>Adding a new post.</p>`;

      setTimeout(() => {
        elem.innerHTML = `<p>A new post has been added.</p>`;
      }, 1000);
    };

    await voiceNotification();

    await this.editor.clear();

    this.setState({
      editorState: Draft.EditorState.createEmpty(),
    });
  }

  render() {
    const { isChangingClassRoom, isEducator, isSavingPost } = this.props;
    const { scheduleDialogOpen } = this.state;

    if (isChangingClassRoom) {
      return null;
    }

    const placeHolder = isEducator
      ? 'Share something or post a formative assessment'
      : 'Ask or share something, this is your space too';

    return (
      <div style={style.wrapper}>
        <div
          style={style.container}
          className="createPostFeatureAnchor"
          data-testid="create-post-container"
          id="create-post-container"
        >
          <div
            style={style.editorWrapper}
            data-testid="create-post-editor-wrapper"
          >
            <Editor
              wrappedRef={(r) => {
                this.editor = r;
              }}
              type="createpost"
              autoFocus
              style={style.editor}
              onChange={(editorState) => this.setState({ editorState })}
              disabled={isSavingPost}
              placeholder={placeHolder}
              pluginsConfigs={{
                textFormatter: { inverted: true },
                file: {
                  ignore: (cb) => {
                    this.ignore = cb;
                  },
                },
              }}
              actionButton={{
                label: 'Post',
                onClick: () => {
                  this.handleCreatePost();
                },
                showLoader: isSavingPost,
                styles: {
                  button: {
                    fontSize: 16,
                    padding: '6px 20px',
                    backgroundColor: colors.designSystem.purple70,
                  },
                  disabledButton: {
                    fontSize: 16,
                    padding: '6px 20px',
                  },
                },
              }}
              secondaryAction={{
                label: 'Schedule for later',
                tooltip: 'Schedule for later',
                Icon: ScheduleIcon,
                onClick: this.handleScheduleOpen,
              }}
            />
          </div>
        </div>
        <SchedulePostDialog
          open={scheduleDialogOpen}
          onClose={this.handleScheduleClose}
          onSchedule={this.handleSchedulePost}
          onReschedule={noop}
        />
        <div
          css={[styleUtils.visuallyHidden()]}
          aria-live="polite"
          role="status"
          ref={this.myRef}
        ></div>
      </div>
    );
  }
}

ClassRoomCreatePost.propTypes = {
  spaceId: PropTypes.string,
  isChangingClassRoom: PropTypes.bool,
  isInInbox: PropTypes.bool.isRequired,
  createPost: PropTypes.func.isRequired,
  isEducator: PropTypes.bool.isRequired,
  isSavingPost: PropTypes.bool.isRequired,
};

ClassRoomCreatePost.defaultProps = {
  spaceId: null,
  isChangingClassRoom: false,
};
export default ClassRoomCreatePost;
